import { useQuery } from "@tanstack/react-query";
import OrderServices from "../services/orderServices";

export const useGetMobileConfig = () => {
  return useQuery({
    queryKey: ["GET_MOBILE_CONFIG"],
    queryFn: async () => {
      const response = await OrderServices.getMobileConfig();
      return {
        orca_shipment_refetch_cooldown_seconds:
          response.orca_shipment_refetch_cooldown_seconds,
        orca_order_refetch_cooldown_seconds:
          response.orca_order_refetch_cooldown_seconds,
      };
    },
    staleTime: Infinity,
  });
};
